(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var container = document.getElementById('herbalifepopup');
    if (!container) return;

    // Leggi URL immagine da Liquid (passato via data-attr in home)
    var imgMd = container.getAttribute('data-img-md') || '';

    // Inject CSS una volta sola
    if (!document.getElementById('herbalife-popup-style')) {
      var style = document.createElement('style');
      style.id = 'herbalife-popup-style';
      style.textContent =
        "html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}" +
        "body{margin:0;font-family:'Helvetica','Arial',sans-serif!important}" +
        "p{margin:0.5em}" +
        "p.para-lead{font-size:1.2em;margin:0.75em}" +
        "a{background-color:transparent;-webkit-text-decoration-skip:objects}" +
        "a:active,a:hover{outline-width:0}" +
        "#herbalifepopup p,#herbalifepopup h1{font-family:'Helvetica','Arial',sans-serif!important;color:#6c6d70!important}" +
        ".herbalife-popup{position:fixed!important;top:0!important;right:0!important;bottom:0!important;left:0!important;z-index:999999!important;text-align:center!important;display:none;color:#6c6d70!important}" +
        ".herbalife-bg{position:absolute!important;top:0!important;right:0!important;bottom:0!important;left:0!important;background:#000!important;opacity:.9!important;z-index:999998!important}" +
        ".herbalife-wrap{min-width:400px!important;height:auto!important;max-height:100%!important;position:absolute!important;top:50%!important;left:50%!important;z-index:999999!important;transform:translate(-50%,-50%)!important;margin:0 auto!important;color:#6c6d70!important}" +
        ".herbalife-content{position:relative!important;display:inline-block!important;padding:15px!important;background:#fff!important;color:#6c6d70!important}" +
        ".herbalife-info{position:relative!important;float:left!important;padding:15px!important;border:3px solid #7ac142!important;color:#6c6d70!important}" +
        ".herbalife-info h1{width:calc(100% - 2rem)!important;margin:0 0 15px 0!important;padding:0!important;font-size:18px!important;line-height:1!important;font-weight:bold!important;color:#6c6d70!important}" +
        ".herbalife-info .herbalife-close{position:absolute!important;top:5px!important;right:10px!important;background:#7ac142!important;border-radius:50%!important;font-size:12px!important;font-weight:bold;color:#fff!important;padding:8px!important;text-decoration:none!important;text-align:center!important;cursor:pointer!important;line-height:8px}" +
        ".herbalife-info .herbalife-close:hover{background:#6c6d70!important}" +
        ".herbalife-info .herbalife-row{position:relative!important;float:left!important;color:#6c6d70!important}" +
        ".herbalife-info .left-col{width:60%!important;position:relative!important;float:left!important;color:#6c6d70!important}" +
        ".herbalife-info .left-col.border{width:calc(60% - 16px)!important;padding:0 15px 0 0!important;color:#6c6d70!important}" +
        ".herbalife-info .left-col img{max-width:100%!important;height:auto;color:#6c6d70!important}" +
        ".herbalife-info .left-col img.f-right{float:right!important;margin:10px 0 0 0!important;color:#6c6d70!important}" +
        ".herbalife-info .right-col{width:40%!important;position:relative!important;float:left!important;color:#6c6d70!important}" +
        ".herbalife-info .right-col.border{width:calc(40% - 15px)!important;padding:0 0 0 15px!important;color:#6c6d70!important;border-left:1px solid #7ac142!important}" +
        ".herbalife-info .right-col p.copy{margin:15px 0 0 0!important;font-size:14px!important;line-height:1.2!important;color:#6c6d70!important}" +
        ".herbalife-info .right-col p span{color:#7ac142!important}" +
        ".herbalife-info p a{font-weight:bold;text-decoration:none;color:#6c6d70!important}" +
        ".clear{height:0!important;line-height:0!important;clear:both!important}" +
        "@media screen and (max-width:767px){" +
          ".herbalife-wrap{overflow-y:auto;min-width:90%!important}" +
          ".herbalife-info .left-col,.herbalife-info .right-col,.herbalife-info .left-col.border,.herbalife-info .right-col.border{width:100%!important;margin:0 0 10px 0!important;padding:0!important;border:0!important}" +
          ".herbalife-info .left-col.border{text-align:center!important}" +
          ".herbalife-info h1{font-size:.95em!important;line-height:1.2em!important}" +
          ".herbalife-info .right-col,.herbalife-info .right-col.border{margin:0!important}" +
          ".herbalife-info .left-col{margin:0!important}" +
          ".herbalife-info .left-col img.f-right{float:left!important;margin:5px 0 0 0!important}" +
          ".para-lead{font-size:1em!important}" +
          "p{font-size:.85em;line-height:1.4em!important}" +
        "}" +
        "@media screen and (min-width:768px){.herbalife-wrap{min-width:768px!important}}" +
        "@media screen and (min-width:850px){.herbalife-wrap{min-width:850px!important}}";
      document.head.appendChild(style);
    }

   // Costruzione popup
container.innerHTML =
  '<div class="herbalife-popup" id="wc_herba_popup">' +
    '<div class="herbalife-bg" data-close="1"></div>' +
    '<div class="herbalife-wrap">' +
      '<div class="herbalife-content">' +
        '<div class="herbalife-info">' +
          '<a class="herbalife-close" href="#" aria-label="Lukk">x</a>' +
          '<p class="para-lead">Dette nettstedet drives av følgende uavhengige Herbalife-medlem: ' +
            (imgMd ? '<img src="' + encodeURI(imgMd) + '" style="height:20px;vertical-align:middle;" alt="">' : '') +
          '</p>' +
          '<div class="herbalife-row">' +
            '<div class="left-col border">' +
              '<h1>ALLEREDE KUNDE?</h1>' +
              '<p>Din personlige kontakt med din Herbalife-representant er avgjørende for din suksess.' +
              (imgMd ? ' <img src="' + encodeURI(imgMd) + '" style="height:20px;vertical-align:middle;" alt="">' : '') +
              ' Hvis dette ikke er din kontakt, vennligst handle via din eksisterende kontakt. Eller <a class="close-link" href="#">klikk her</a> for å fortsette.</p>' +
            '</div>' +
            '<div class="right-col border">' +
              '<h1>ALLEREDE MEDLEM I HERBALIFE?</h1>' +
              '<p>For å handle via din egen medlemskonto, besøk myherbalife.com.</p>' +
            '</div>' +
          '</div>' +
          '<p>Jeg hjelper deg gjerne å nå dine mål. Med riktige produkter, en pålitelig Herbalife-partner og et engasjert community øker sjansene dine. <a class="close-link" href="#">[Klikk her for å fortsette]</a></p>' +
          '<div class="clear"></div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';

    var popupEl = document.getElementById('wc_herba_popup');
    var closeBtn = popupEl.querySelector('.herbalife-close');
    var closeLinks = popupEl.querySelectorAll('.close-link');
    var backdrop   = popupEl.querySelector('.herbalife-bg');

if (popupEl) {
  popupEl.addEventListener('click', function () {
    wcHidePopUp();
  });
}

    function preventAnchorDefault(e) {
      if (e && e.preventDefault) e.preventDefault();
    }
    function wcSetCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + (days*24*60*60*1000));
      document.cookie = name + "=" + (value || "") + "; expires=" + d.toUTCString() + "; path=/";
    }
    function wcGetCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return "";
    }
    function wcHidePopUp() {
      if (popupEl) popupEl.style.display = 'none';
      wcSetCookie('wc_popup_herba', 'shown', 30);
    }

    if (closeBtn) closeBtn.addEventListener('click', function (e) { preventAnchorDefault(e); wcHidePopUp(); });
    closeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) { preventAnchorDefault(e); wcHidePopUp(); });
    });
    if (backdrop) backdrop.addEventListener('click', wcHidePopUp);

    var cookie_content = wcGetCookie('wc_popup_herba');
    if (cookie_content !== 'shown') {
      popupEl.style.display = 'block';
      wcSetCookie('wc_popup_herba','shown',30);
    }
  }
})();


